import IconButton from "@material-ui/core/IconButton";
import FaceBook from "../icons/FaceBook";
import Instagram from "../icons/Instagram";
import WhatsApp from "../icons/WhatsApp";

function Footer(){

  return (
    <>
    <div className="footer-contact">
      <h2>Contact details</h2>
      <p>
        <strong>Shri Nandhi Dairy Farm</strong>
        <br/>
        Udumalpet, Tirupur DT
        <br/>
        <br/>
        <strong>Email: </strong>shrinandhidairyfarm@gmail.com
        <br/>
        <strong>Mobile: </strong>+91 9952640003 &amp; +91 9629454631
        <br/>
        <IconButton>
          <WhatsApp />
        </IconButton>
        <IconButton>
          <FaceBook />
        </IconButton>
        <IconButton>
          <Instagram />
        </IconButton>
      </p>
    </div>
    <div className="footer">
      website developed &amp; maintained by <a rel={'noreferrer'} target="_blank" href="https://doodz-tech.business.site/">Doodz tech</a>
    </div>
    </>
  )
}

export default Footer;